module.exports = __webpack_public_path__ + "static/img/credencial-4.5487dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credencial-4.png
// module id = iWvB
// module chunks = 1